import { ChargerProducts } from '../common/enums/Products'
import { ChargePointImport } from '../common/redux/api/web-api'

const isAura = (entity: { productId?: number | null } | number): boolean => {
    const productId = typeof entity === 'number' ? entity : entity?.productId

    return productId === ChargerProducts.Aura || productId === ChargerProducts.Aura2
}

export const isAuraImport = (chargePoint: ChargePointImport | undefined) =>
    chargePoint?.productType === 'Aura' || chargePoint?.productType === 'Aura2'

export default isAura
